import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "codeCheck" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("手机号")
const _hoisted_3 = { class: "qiyeBox" }
const _hoisted_4 = { class: "qiyeBox" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("验证码")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 登陆/注册 ")
const _hoisted_7 = { class: "text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("登录代表您已阅读并同意 "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://ai.cemeta.cenmetahome.cn/article" }, "《隐私条款》"),
  /*#__PURE__*/_createTextVNode(" 和"),
  /*#__PURE__*/_createElementVNode("a", { href: "https://ai.cemeta.cenmetahome.cn/service" }, "《用户协议》")
], -1)

import { reactive, ref } from 'vue';
import type { FormInstance, FormRules } from 'element-plus';
import Api from '@/api';
import { RootState } from '@/store/stateModel';
import { useStore, Store } from 'vuex';
import { useRouter } from 'vue-router';

// eslint-disable-next-line no-import-assign
import { ElMessage } from 'element-plus';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


// eslint-disable-next-line quotes
const router = useRouter();

const ruleFormRef = ref<FormInstance>();
//表单 数据定义
const ruleForm = reactive({
    account: '',
    code: '',
    companyId: '',
    value: '',
    teamId:''
});
const options = ref([]);
const isDisabled = ref(false);
const timer = ref();
const teamArr=ref([])
const getCodeText = ref('获取验证码');
const iShowSelect = ref(false);
const isCheckBox = ref(false);
const isShowTeam=ref(false)//TODO(团队选择显示): 
//获取登陆方式
const getlogin = async () => {
    let account = ruleForm.account;
    const result = await Api.Application.getLoginList(account);

    options.value = result.data;
};

//跳转隐私条款
const privacyText = () => {
    router.push('https://ai.cemeta.cenmetahome.cn/article');
};
//跳转用户条钻
const Agreement = () => {
    router.push('https://ai.cemeta.cenmetahome.cn/service');
};


//验证码输入事件
const validatePass1 = (rule: any, value: string, callback: any) => {
    if (value === '') {
        callback(new Error('验证码不能为空'));
    } else {
        if (ruleForm.code !== '') {
            if (!ruleFormRef.value) {
                return;
            }
            ruleFormRef.value.validateField('checkPass', () => null);
        }
        callback();
    }
};
//

//选择企业登陆
const selectEnterprise = async (id: string,name:string) => {
    ruleForm.companyId = id;
    isShowTeam.value=true
    sessionStorage.setItem('companyId', id);
    //调用获取团队接口
    let team= await Api.Application.getTeam({keyword: name, noToken: true, phone: ruleForm.account})
    if(team.data){
        let {teamList}=team.data
teamArr.value=teamList
    }
};
//选择团队
const selectTeam=(id:string,name:string)=>{
      ruleForm.teamId=id
    sessionStorage.setItem('teamId', id);
}

//手机号输入事件
const validatePass = (rule: any, value: string, callback: any) => {
    if (value === '') {
        callback(new Error('手机号不能为空'));
    } else if (!/^\d{11}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'));
    } else {
        getlogin();
        isDisabled.value = true;
        callback();
        iShowSelect.value = true;
    }
};

let count = 60;
//获取验证码
const getCode = async () => {
    if (!isDisabled.value) {
        return;
    }
    ruleForm.code = '';
    isDisabled.value = false;
    let result = await Api.Application.getmessCode(ruleForm.account, 'login-phone-code');

    isDisabled.value = false;
    timer.value = setInterval(() => {
        if (count > 0) {
            count--;
            getCodeText.value = `倒计时${count}s`;
            return;
        } else {
            getCodeText.value = '获取验证码';
            timer.value = null;
            isDisabled.value = true;

        }
    }, 1000);
};

const store: Store<RootState> = useStore();
//正则事件
const rules = reactive<FormRules<typeof ruleForm>>({
    account: [{ validator: validatePass, trigger: ['change', 'blur'] }],
    code: [{ validator: validatePass1, trigger: ['change', 'blur'] }]
});

// login()
const loginByCode = async (account: string, code: string, companyId: string,teamId:string): Promise<void> => {
    store.dispatch('user/login', { type: 'code', phone: account, code: code, companyId: companyId,teamId: teamId,noToken:true });
};
// 提交按钮点击事件
const submitForm = (formEl: FormInstance | undefined) => {
    if (!formEl) {
        return;
    }
    formEl.validate((valid) => {
        if (valid) {
            if (!isCheckBox.value) {
                ElMessage({
                    message: '请先同意《隐私协议》与《用户协议》',
                    type: 'warning'
                });
                return;
            }
            loginByCode(ruleForm.account, ruleForm.code, ruleForm.companyId,ruleForm.teamId);

        } else {
            return false;
        }
    });
};



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_font = _resolveComponent("font")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['ruleFormRef'] = _value
        ruleFormRef.value = _value
      },
      model: _unref(ruleForm),
      "status-icon": "",
      rules: _unref(rules),
      "label-width": "120px",
      class: "demo-ruleForm"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "account"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(ruleForm).account,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(ruleForm).account = $event)),
              placeholder: "请输入手机号"
            }, {
              prepend: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          (iShowSelect.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "企业"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(ruleForm).value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(ruleForm).value = $event)),
                    placeholder: "请选择企业",
                    onChange: _ctx.componyChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value?.company, (v, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: i,
                          label: v.name,
                          value: v.name,
                          onClick: ($event: any) => (selectEnterprise(v.id,v.name))
                        }, null, 8, ["label", "value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (isShowTeam.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "团队"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(ruleForm).teamId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(ruleForm).teamId = $event)),
                    placeholder: "请选择团队",
                    onChange: _ctx.teamChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamArr.value, (v, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: i,
                          label: v.name,
                          value: v.id,
                          onClick: ($event: any) => (selectTeam(v.id,v.name))
                        }, null, 8, ["label", "value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "code"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(ruleForm).code,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(ruleForm).code = $event)),
              placeholder: "请输入验证码"
            }, {
              prepend: _withCtx(() => [
                _hoisted_5
              ]),
              append: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: getCode,
                  class: "getCodeBtn",
                  "aria-disabled": !isDisabled.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font, {
                      style: _normalizeStyle(isDisabled.value ? 'color:#000' : 'color:#ccc')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getCodeText.value), 1)
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }, 8, ["aria-disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "submitBtn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(ruleFormRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_checkbox, {
            id: "checkBox",
            modelValue: isCheckBox.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (isCheckBox.value = $event)),
            size: "large"
          }, null, 8, ["modelValue"]),
          _hoisted_8
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})